<template>
  <v-sheet tile color="#ffffff">
    <v-container>
      <div>
        <v-form v-model="isValid">
          <div>
            <v-text-field
              background-color="#F4F7FC"
              filled
              light
              required
              v-model="username"
              label="Email"
              autocorrect="off"
              autocapitalize="none"
              :rules="[v => !!v || 'Email is required']"
              ref="email_field"
              v-on:keyup.enter="refocuOrSignIn"
              @input="resetError"
            />
          </div>
          <div>
            <v-text-field
              filled
              background-color="#F4F7FC"
              light
              required
              ref="password_field"
              autocorrect="off"
              autocapitalize="none"
              :rules="[v => !!v || 'Password is required']"
              :append-icon="show_new_pass ? 'visibility' : 'visibility_off'"
              :type="show_new_pass ? 'text' : 'password'"
              @click:append="show_new_pass = !show_new_pass"
              v-model="password"
              label="Enter your password"
              v-on:keyup.enter="signIn"
              @input="resetError"
            />
          </div>
          <v-slide-y-transition>
            <div v-if="show_code">
              <v-text-field
                key="code-input"
                background-color="#F4F7FC"
                filled
                light
                required
                v-model="code"
                label="Code"
                @input="resetError"
                autocomplete="one-time-code"
                :rules="[v => !!v || 'Code is required']"
                ref="code_field"
                type="numeric"
                name="code"
              />
            </div>
          </v-slide-y-transition>
        </v-form>
      </div>
      <br />
      <div class="error pa-2 white--text rounded" v-if="error">
        <span class="mr-2">{{ error }}</span>
        <v-btn v-if="reconfirm" @click="resend" color="white" tile outlined
          >Confirm</v-btn
        >
      </div>
      <br />
      <v-slide-y-transition>
        <v-btn
          @click="confirmUser"
          class="mb-2"
          key="confirm-btn"
          v-if="code && show_code"
          color="primary"
          large
          block
        >
          Verify Email
        </v-btn>
      </v-slide-y-transition>
      <div class="buttons-container">
        <v-btn large :disabled="!isValid" color="primary" v-on:click="signIn"
          >Sign In</v-btn
        >
        <v-btn large outlined color="primary" v-on:click="signUp"
          >Create account</v-btn
        >
      </div>
        <!-- <v-btn
          block
          color="primary"
          class="mt-8"
          v-on:click="socialLogin('Google')"
        >
          Sign In With Google
        </v-btn> -->
      <!-- <v-btn
       block
        color="primary"
        class="mt-4"
         v-on:click="socialLogin('Facebook')"
        >Sign In With Facebook</v-btn
      >  --> 
      <v-btn
        small
        color="primary"
        class="forgot-pass-button"
        text
        block
        v-on:click="forgot"
        >Forgot password</v-btn
      >
    </v-container>
    <v-snackbar top color="white" v-model="snackbar">
      <span class="primary--text"
        >We sent the Verification Code at
        <v-chip color="primary" label>{{ username }}</v-chip>
      </span>
    </v-snackbar>
  </v-sheet>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { createUserInfo, updateUserInfo } from "../graphql/mutations";
import { getUserInfo } from "../graphql/queries";
import { Auth } from "aws-amplify";

export default {
  name: "SignIn",
  props: ["user"],
  data() {
    return {
      snackbar: false,
      code: "",
      show_code: false,
      reconfirm: false,
      username: "",
      password: "",
      error: "",
      show_new_pass: false,
      isValid: false
    };
  },
  mounted() {
    var that = this;
    setTimeout(() => {
      if (that.$refs.email_field) {
        that.$refs.email_field.focus();
      }
    }, 50);
    this.$nextTick(() => {
      if (that.$refs.email_field) {
        that.$refs.email_field.focus();
      }
    });
  },
  methods: {
    resetError: function() {
      this.error = "";
    },
    resend() {
      this.reconfirm = false;

      this.$Amplify.Auth.resendSignUp(this.username)
        .then(() => {
          this.resetError();
        })
        .catch(e => {
          this.setError(e);
        })
        .finally(() => {
          if (!this.error) {
            this.snackbar = true;
            this.show_code = true;
            this.reconfirm = true;
          } else {
            this.show_code = false;
            this.snackbar = false;
          }
        });
    },
    signIn: function(event) {
      this.resetError();
      this.$store.dispatch("startForcedLoad");
      this.$Amplify.Auth.signIn(this.username.toLowerCase(), this.password)
        .then(data => {
          this.$store.dispatch(
            "setOwnerId",
            data.signInUserSession.idToken.payload.sub
          );

          // try {
          //    var ownerId= data.signInUserSession.idToken.payload.sub;
          //    OneSignal.push(function() {
          //     OneSignal.setExternalUserId(ownerId);
          //   });
          // } catch (error) {
          // }

          this.$Amplify.API.graphql(
            this.$Amplify.graphqlOperation(getUserInfo, {
              owner: data.signInUserSession.idToken.payload.sub
            })
          )
            .then(res => {
              if (res.data.getUserInfo !== null) {
                var email = data.signInUserSession.idToken.payload.email;
                var username = data.signInUserSession.idToken.payload.sub;
                var phone = data.signInUserSession.idToken.payload.phone_number;
                var receivePush = true;
                var receiveEmail = true;
                var receiveSMS = true;

                if (res.data.getUserInfo.phone === null && phone !== "") {
                  try {
                    this.updateUserInformation(
                      email,
                      username,
                      phone,
                      receivePush,
                      receiveEmail,
                      receiveSMS
                    );
                  } catch (error) {}
                } else if (res.data.getUserInfo.email !== email) {
                  try {
                    this.updateUserInformation(
                      email,
                      username,
                      phone,
                      receivePush,
                      receiveEmail,
                      receiveSMS
                    );
                  } catch (error) {}
                }
              } else {
                var email = data.signInUserSession.idToken.payload.email;
                var username = data.signInUserSession.idToken.payload.sub;
                var phone = data.signInUserSession.idToken.payload.phone_number;
                var receivePush = true;
                var receiveEmail = true;
                var receiveSMS = true;
                this.createUserInformation(
                  email,
                  username,
                  phone,
                  receivePush,
                  receiveEmail,
                  receiveSMS
                );
              }
            })
            .catch(e => {});

          this.$store.dispatch("stopForcedLoad");
          return AmplifyEventBus.$emit("authState", "signedIn");
        })
        .catch(e => {
          this.$store.dispatch("stopForcedLoad");
          this.setError(e);
          if (e.name === "UserNotConfirmedException") {
            this.reconfirm = true;
          } else {
            this.reconfirm = false;
          }
        });
    },
    socialLogin: function(providerParam) {
      Auth.federatedSignIn({ provider: providerParam }).then(res => {
        console.log("google response : ", res);
      });
      console.log("click sign In to ",providerParam );
    },
   
    checkUSer: function() {
      const user = Auth.currentAuthenticatedUser();
      console.log("user : ", user);
    },
    forgot: function() {
      AmplifyEventBus.$emit("authState", "forgotPassword");
    },
    signUp: function() {
      AmplifyEventBus.$emit("authState", "signUp");
    },
    confirmUser() {
      this.$Amplify.Auth.confirmSignUp(this.username, this.code)
        .then(() => {
          this.signIn();
        })
        .catch(e => this.setError(e));
    },
    updateUserInformation(
      email,
      cognitoUserName,
      phone,
      receivePush,
      receiveEmail,
      receiveSMS
    ) {
      this.$store.dispatch("startLoading");
      this.$Amplify.API.graphql(
        this.$Amplify.graphqlOperation(updateUserInfo, {
          input: {
            email: email,
            owner: cognitoUserName,
            phone: phone,
            // receivePush: receivePush,
            // receiveEmail: receiveEmail,
            // receiveSMS: receiveSMS,
            // createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          }
        })
      )
        .then(res => {
          this.$store.dispatch("stopLoading");
        })
        .catch(e => {
          this.$store.dispatch("stopLoading");
          process_api_error(`Error Creating Create User information`, e);
        });
    },

    createUserInformation(
      email,
      cognitoUserName,
      phone,
      receivePush,
      receiveEmail,
      receiveSMS
    ) {
      this.$store.dispatch("startLoading");
      this.$Amplify.API.graphql(
        this.$Amplify.graphqlOperation(createUserInfo, {
          input: {
            email: email,
            owner: cognitoUserName,
            phone: phone,
            receivePush: receivePush,
            receiveEmail: receiveEmail,
            receiveSMS: receiveSMS,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          }
        })
      )
        .then(res => {
          this.$store.dispatch("stopLoading");
        })
        .catch(e => {
          this.$store.dispatch("stopLoading");
          process_api_error(`Error Creating Create User information`, e);
        });
    },

    setError: function(e) {
      if (e.message && e.message.startsWith("2 validation errors detected")) {
        this.error = "Invalid email format";
      } else {
        this.error = e.message || e;
      }
    }
  }
};
</script>
<style lang="scss">
.forgot-pass-button {
  margin-top: 16px;
  display: block;
}
</style>
<style lang="scss" scoped>
.buttons-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  @media screen and (max-width: 599px) {
    grid-template-columns: 1fr;
  }
}

.contain-image {
  & img {
    width: 2rem;
    height: 2rem;
  }
}

.login-helper {
  .forgot-pass-button {
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/Auth/SignIn.vue